import { Action } from '@ngrx/store';

export enum ModelPortfolioSubscriptionActionTypes {
    UNSUBSCRIBE_PORTFOLIO = 'UNSUBSCRIBE_PORTFOLIO',
    LOAD_MODEL_PORTFOLIO_CUSTOMER_SECURITIES = 'LOAD_MODEL_PORTFOLIO_CUSTOMER_SECURITIES',
    LOAD_MODEL_PORTFOLIO_CUSTOMER_SECURITIES_SUCCESS = 'LOAD_MODEL_PORTFOLIO_CUSTOMER_SECURITIES_SUCCESS',
    CREATE_ORDERS = 'CREATE_ORDERS',
    DOWNLOAD_MUTATIONS = 'DOWNLOAD_MUTATIONS',
    APPROVE_MUTATIONS = 'APPROVE_MUTATIONS',
    DISAPPROVE_MUTATIONS = 'DISAPPROVE_MUTATIONS',
    VIEW_ORDERS = 'VIEW_ORDERS',
    CANCEL_ORDERS = 'CANCEL_ORDERS',
    VIEW_ORDER_STATUS = 'VIEW_ORDER_STATUS',
    REBALANCE = 'REBALANCE',
    MODEL_PORTFOLIOS_SUBSCRIPTION_DATA_ERROR = 'MODEL_PORTFOLIOS_SUBSCRIPTION_DATA_ERROR',
    SUBMIT_MODELPORTFOLIO_SUBSCRIPTION = 'SUBMIT_MODELPORTFOLIO_SUBSCRIPTION',
    SUBMIT_MODELPORTFOLIO_SUBSCRIPTION_SUCCESS = 'SUBMIT_MODELPORTFOLIO_SUBSCRIPTION_SUCCESS'
}

export class SubmitModelPortfolioSubscription implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.SUBMIT_MODELPORTFOLIO_SUBSCRIPTION;
  constructor(public payload: any) { }
}
export class SubmitModelPortfolioSubscriptionSuccess implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.SUBMIT_MODELPORTFOLIO_SUBSCRIPTION_SUCCESS;
  constructor(public payload: string) { }
}
export class UnsubscribePortfolio implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.UNSUBSCRIBE_PORTFOLIO;
  constructor(public payload: any) { }
}
export class CreateOrders implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.CREATE_ORDERS;
  constructor(public payload: any) { }
}
export class DownloadMutations implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.DOWNLOAD_MUTATIONS;
  constructor(public payload: any) { }
}
export class ApproveMutations implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.APPROVE_MUTATIONS;
  constructor(public payload: any) { }
}
export class DisapproveMutations implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.DISAPPROVE_MUTATIONS;
  constructor(public payload: any) { }
}
export class ViewOrders implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.VIEW_ORDERS;
  constructor(public payload: any) { }
}
export class CancelOrders implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.CANCEL_ORDERS;
  constructor(public payload: any) { }
}
export class ViewOrderStatus implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.VIEW_ORDER_STATUS;
  constructor(public payload: any) { }
}
export class ReBalance implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.REBALANCE;
  constructor(public payload: any) { }
}
export class ModelPortfoliosSubscriptionDataError implements Action {
  readonly type = ModelPortfolioSubscriptionActionTypes.MODEL_PORTFOLIOS_SUBSCRIPTION_DATA_ERROR;
  constructor(public payload: string) { }
}

export type ModelPortfolioSubscriptionActions = UnsubscribePortfolio | CreateOrders | DownloadMutations |  ApproveMutations | DisapproveMutations |
ViewOrders | CancelOrders | ViewOrderStatus | ReBalance | SubmitModelPortfolioSubscription | SubmitModelPortfolioSubscriptionSuccess | ModelPortfoliosSubscriptionDataError;
